import { Button } from 'components/ui/button';
import seliseSmallLogo from 'assets/images/selise_ai_small.png';
import { LoginOption } from 'constant/sso';
import { useConfig } from 'hooks/use-config';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type SigninOidcProps = Readonly<{
  loginOption: LoginOption;
}>;

export function SigninOidc({ loginOption }: SigninOidcProps) {
  const { configurationSettings } = useConfig();
  const oidcClientId = loginOption.oidc?.clientId;
  const oidcRedirectUri = loginOption.oidc?.redirectUrl;
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { t } = useTranslation();

  const oidcClickHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!oidcClientId || !oidcRedirectUri) {
      return;
    }

    setIsRedirecting(true);

    const oidcUrl =
      `https://${configurationSettings.paths.baseUrl}` +
      `/idp/v1/Authentication/authorize?X-Blocks-Key=${configurationSettings.blocksKey}` +
      `&client_id=${encodeURIComponent(oidcClientId)}` +
      `&redirect_uri=${encodeURIComponent(oidcRedirectUri)}` +
      `&response_type=code&scope=openid`;

    window.location.href = oidcUrl;
  };

  if (!oidcClientId || !oidcRedirectUri) return null;

  return (
    <Button type="button" className="h-12 w-full font-bold" variant="outline" onClick={oidcClickHandler}>
      <img src={seliseSmallLogo} width={25} height={25} alt="Blocks logo" className="mr-2" />
      Login with blocks
    </Button>
  );
}
